export default "__VITE_ASSET__518975b2__"